import { Injectable } from '@angular/core';
import { ActiveState, EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { CourseGeneral } from '@data/course-general/course-general.model';

export interface CourseGeneralState
  extends EntityState<CourseGeneral, CourseGeneral['_id']>, ActiveState<CourseGeneral['_id']> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'course-general', resettable: true, idKey: '_id' })
export class CourseGeneralStore extends EntityStore<CourseGeneralState> {
  constructor() {
    super();
  }
}
